import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { FC } from "react"
import "./RightsBlock.less"

const { Text } = WebsiteTypography

const RightsBlock: FC = () => {
  return (
    <div className={"rights-reserved-block"}>
      <Text color={"website-secondary"} weight={"w300"} size={"md"} className={"rights-text"}>
        © {new Date().getFullYear()}
        <span>{" easetech. "}</span>
        All Rights Reserved
      </Text>
    </div>
  )
}

export default RightsBlock
